import Highcharts, { color } from "highcharts";
import Exporting from "highcharts/modules/exporting";
Exporting(Highcharts);
import accessibility from "highcharts/modules/accessibility";
accessibility(Highcharts);
import mapModule from "highcharts/modules/map";
// import mapData from "@highcharts/map-collection/custom/world.geo.json";
import mapData from "../json/world-palestine-highres.geo.json";
mapModule(Highcharts);

jQuery(function ($) {
  // use tema-highcharts class to identify all highcharts related elements
  // it is a generic class to identify there is a chart on the page
  // and to not exit early from this script
  if ($("#chart-country, #country-map, .tema-highcharts, #gender-quota-home-map").length <= 0) {
    return;
  }

  console.log("Database Maps & Charts ready");

  let yAxisMax = 0;
  let compareCharts = [];

  let ajaxRequests = [];

  // Single question donut chart with API ///////////////////////////////////////////////////
  $(".highcharts-donut-question-breakdown-api").each(function (index) {
    const elm = $(this);
    const id = elm.attr("id");
    const question = elm.data("question");
    const region = elm.data("region");
    const type = elm.data("type");
    const chartType = elm.data("chart-type") || "pie";

    const url =
      "/api/chartdataregion?question=" +
      question +
      "&region=" +
      region +
      "&type=" +
      type;

    const settings = {
      url,
      method: "GET",
      timeout: 0,
      headers: {
        "Content-Type": "application/json",
      },
      error: function (error) {
        console.log("error", error);
      },
    };

    const ajaxCall = $.ajax(settings).done(function (response) {
      const question = response.question.title;
      const choices = response.choices;
      const colors = response.colors;
      const values = response.data;
      // const total = response.countriesResearched;
      const total = values.reduce((acc, currentValue) => acc + currentValue, 0);

      let chartTitle = response.themeNames[0];


      if (response.themeNames.length > 1) {
        chartTitle += "<br>";

        response.themeNames.splice(0, 1);

        chartTitle += response.themeNames.join(" - ");
      }

      let data = [];

      choices.map((choice, index) => {
        if (values[index] > 0) {
          data.push({
            name: choice,
            y: values[index],
            color: colors[choice],
          });
        }
      });

      let chartOptions = {
        chart: {
          type: chartType,
          plotShadow: false,
          backgroundColor: "#FFFFFF",
        },
        title: {
          text: question,
        },
        subtitle: {
          text: chartTitle,
        },
        series: [
          {
            name: "Answers",
            data,
          },
        ],
      };

      if (chartType === "pie") {
        chartOptions = {
          ...chartOptions,
          subtitle: {
            text: chartTitle + "<br>" + "Data for " + total + " countries",
          },
          plotOptions: {
            pie: {
              innerSize: "60%",
              dataLabels: {
                enabled: true,
                distance: -50,
                format: "<b>{point.name}</b>: {point.y}",
              },
            },
          },
          tooltip: {
            formatter: function () {
              return (
                // "Total: 4 (" + Math.round(this.y / this.total * 100) + "%)"
                "Total: " + this.y + " (" + ((this.y / this.total) * 100).toFixed(2) + "%)"
              );
            },
          },
        };
      }

      if (chartType === "column") {
        chartOptions = {
          ...chartOptions,
          subtitle: {
            text: chartTitle + "<br>" + "Data for " + total + " countries",
          },
          xAxis: {
            categories: choices,
            crosshair: true,
          },
          yAxis: {
            min: 0,
            title: {
              enabled: false,
            },
          },
          tooltip: {
            headerFormat:
              '<span style="font-size:10px">{point.key}</span><table>',
            formatter: function () {
              return (
                "<tr><td>Total: <b>" +
                this.y +
                "</b> (" +
                ((this.y / total) * 100).toFixed(2) +
                "%)</td></tr>"
              );
            },
            footerFormat: "</table>",
            shared: true,
            useHTML: true,
          },
          plotOptions: {
            column: {
              pointPadding: 0.2,
              borderWidth: 0,
            },
          },
        };
      }

      // Set normalise compare charts yAxis's max value
      let chart = Highcharts.chart(id, chartOptions);
      // compareCharts[index] = chart;

      if (chart.yAxis[0].max > yAxisMax) {
        yAxisMax = chart.yAxis[0].max;
      }

      compareCharts.push(chart);
    });

    ajaxRequests.push(ajaxCall);
  }); // END of $(".highcharts-donut-question-breakdown-api").each

  $.when.apply($, ajaxRequests).done(function () {
    // var results = arguments; // arguments is an array-like object containing the results of each Ajax call
    // const newYAxisMax = Math.ceil(yAxisMax / 10) * 10;
    const newYAxisMax = yAxisMax;

    compareCharts.map((c, idx) => {
      c.yAxis[0].update({
        max: newYAxisMax,
        tickInterval: 5,
      });

      c.update({
        chart: {
          plotHeight: newYAxisMax * 50,
          marginBottom: 150,
        },
      });
    });
  }).fail(function () {
    console.log('One or more Ajax calls failed');
  });

  // Single question donut chart with API ///////////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////////////////////// END

  // Single question column chart with API //////////////////////////////////////////////////
  $(".highcharts-column-question-breakdown-api").each(function () {
    const elm = $(this);
    const id = elm.attr("id");
    const question = elm.data("question");
    const region = elm.data("region");
    const type = elm.data("type");

    const url =
      "/api/chartdataregion?question=" +
      question +
      "&region=" +
      region +
      "&type=" +
      type;

    const settings = {
      url,
      method: "GET",
      timeout: 0,
      headers: {
        "Content-Type": "application/json",
      },
      error: function (error) {
        console.log("error", error);
      },
    };
    $.ajax(settings).done(function (response) {
      const question = response.question.title;
      const choices = response.choices;
      const values = response.data;
      const total = response.countriesResearched;
      let chartTitle = response.themeNames[0];

      if (response.themeNames.length > 1) {
        chartTitle += "<br>";

        response.themeNames.splice(0, 1);

        chartTitle += response.themeNames.join(" - ");
      }

      Highcharts.chart(id, {
        chart: {
          type: "column",
        },
        title: {
          text: question,
        },
        subtitle: {
          text: chartTitle + "<br>" + "Data for " + total + " countries",
        },
        xAxis: {
          categories: choices,
          crosshair: true,
        },
        yAxis: {
          min: 0,
          title: {
            enabled: false,
          },
        },
        tooltip: {
          headerFormat:
            '<span style="font-size:10px">{point.key}</span><table>',
          formatter: function () {
            return (
              "<tr><td>Total: <b>" +
              this.y +
              "</b> (" +
              ((this.y / total) * 100).toFixed(2) +
              "%)</td></tr>"
            );
          },
          footerFormat: "</table>",
          shared: true,
          useHTML: true,
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        series: [
          {
            name: question,
            data: values,
          },
        ],
      });
    });
  });
  // Single question column chart with API //////////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////////////////////// END

  // Charts /////////////////////////////////////////////////////////////////////////
  // /data-tools/data/country?country=135&database_theme=293
  // ////////////////////////////////////////////////////////////////////////////////
  var chartCountry = document.getElementById("chart-country");

  if (chartCountry) {
    var countryId = chartCountry.getAttribute("data-country");

    const settings = {
      url: "/api/chartvoterturnout?type=country&id=" + countryId,
      method: "GET",
      timeout: 0,
      headers: {
        "Content-Type": "application/json",
      },
      error: function (error) {
        console.log("error", error);
      },
    };
    $.ajax(settings).done(function (response) {
      var data = response;
      const selectStartYear = $("#vtd-highcharts-data-startyear");
      const selectEndYear = $("#vtd-highcharts-data-endyear");
      const buttonApply = $("#vtd-highcharts-timerange-apply");
      const buttonReset = $("#vtd-highcharts-timerange-reset");
      const message = $("#vtd-highcharts-timerange-message");

      var years = [];
      data.forEach(function (dataset) {
        dataset.data.forEach(function (data) {
          if (!years.includes(data.year) && data.value !== null) {
            years.push(data.year);
          }
        });
      });

      years.sort();

      var datasets = [];
      data.forEach(function (dataset) {
        var newDataset = {
          name: dataset.title,
          data: [],
        };

        years.forEach(function (year) {
          var dataItem = dataset.data.find(function (item) {
            return item.year === year;
          });

          if (dataItem) {
            newDataset.data.push(dataItem.value);
          } else {
            newDataset.data.push(null);
          }
        });

        datasets.push(newDataset);
      });

      // Sort datasets by custom order
      const ref = ["Parliamentary", "Presidential", "EU"];

      let sortedDatasets = [];
      ref.map((r, idx) => {
        datasets.map((item) => {
          if (item.name.indexOf(r) > -1) {
            sortedDatasets.push(item);
          }
        });
      });

      // console.log('years', years);
      // console.log('sortedDatasets', sortedDatasets);

      var customTickPositions = [0, 20, 40, 60, 80, 100];
      var chart = new Highcharts.Chart({
        chart: {
          renderTo: "chart-country",
          // marginBottom: 110,
          // marginTop: 80,
        },
        title: { text: "" },
        legend: {
          enabled: false,
        },
        exporting: {
          buttons: {
            contextButton: {
              theme: {
                style: {
                  fontFamily: "Verdana, sans-serif",
                  color: "#eb6f42",
                },
              },
            },
          },
        },
        xAxis: {
          categories: years.map(String),
        },
        yAxis: {
          title: "",
          tickPositions: customTickPositions,
          labels: {
            format: "{text}%",
          },
        },
        title: {
          text: "Voter Turnout",
          style: {
            fontSize: "22px",
            fontFamily: "Inter, sans-serif",
          },
        },
        plotOptions: {
          line: {
            connectNulls: true,
          },
          series: {
            marker: {
              enabled: false,
              states: {
                hover: {
                  enabled: true,
                },
              },
            },
            events: {
              legendItemClick: function () {
                // return false;
                var visibility = this.visible ? "visible" : "hidden";
                console.log("visibility", visibility);
              },
            },
          },
        },
        series: sortedDatasets,
      });

      // Populate start year and end year select list
      years.map((y, i) => {
        selectStartYear.append('<option value="' + y + '">' + y + "</option>");
        selectEndYear.append('<option value="' + y + '">' + y + "</option>");
      });

      selectStartYear.find("option").last().remove();
      selectEndYear.find("option").first().remove();
      selectEndYear.val(years[years.length - 1]);
      selectEndYear.trigger("change");

      $("#vtd-highcharts-timerange-wrapper").show();

      function getFilteredTimerangeData(sY, eY) {
        let filteredYears = [];
        let filteredDatasets = [];

        filteredDatasets = sortedDatasets.map((d, i) => {
          return {
            data: [],
            name: d.name,
          };
        });

        years.map((y, i) => {
          if (y >= sY && y <= eY) {
            filteredYears.push(y);
            sortedDatasets.map((d, j) => {
              filteredDatasets[j].data.push(d.data[i]);
            });
          }
        });

        return { filteredYears, filteredDatasets };
      }

      // Apply selected timerange years
      buttonApply.on("click", function () {
        const sY = selectStartYear.val();
        const eY = selectEndYear.val();

        message.hide();

        if (sY >= eY) {
          message.show();
          return false;
        }

        const timerangeData = getFilteredTimerangeData(sY, eY);

        // Update chart xAxis and Series
        chart.xAxis[0].update({
          categories: timerangeData.filteredYears,
        });
        timerangeData.filteredDatasets.map((d, i) => {
          chart.series[i].setData(d.data);
        });
      });

      // Reset chart xAxis and series back to default time range
      buttonReset.on("click", function () {
        message.hide();

        selectStartYear.val(years[0]);
        selectStartYear.trigger("change");
        selectEndYear.val(years[years.length - 1]);
        selectEndYear.trigger("change");

        chart.xAxis[0].update({
          categories: years,
        });
        sortedDatasets.map((d, i) => {
          chart.series[i].setData(d.data);
        });
      });

      // Hide chart title
      chart.setTitle({
        text: "",
        enabled: false,
      });

      const legendsContainer = $($("#chart-country").data("legends"));

      let type = ''
      let html = '';

      sortedDatasets.map((d, i) => {
        const id = "hclcb" + i;

        if (d.name.split(' ')[0] !== type) {
          if (i === 0) {
            html += '<div class="flex flex-wrap">';
          } else {
            html += '</div><div class="flex flex-wrap">';
          }

          type = d.name.split(' ')[0];
        }

        html +=
          '<div class="text-mobileS md:text-desktopS px-4 mb-4 whitespace-nowrap cursor-pointer hc-custom-legend" data-index="' +
          i +
          '">';
        html +=
          '<input type="checkbox" name="' +
          id +
          '" id="' +
          id +
          '" class="mr-2 hclcb" data-index="' +
          i +
          '" checked>';
        html += '<label for="' + id + '">' + d.name + "</label>";
        html += "</div>";

        if ((i + 1) >= sortedDatasets.length) {
          html += "</div>";
        }
      });

      legendsContainer.append(html);

      $(".hclcb").on("change", function () {
        const idx = $(this).data("index");

        if ($(this)[0].checked) {
          chart.series[idx].setVisible(true, true);
          chart.series.map((s, i) => {
            s.setState("inactive");
          });
          chart.series[idx].setState("hover");
        } else {
          chart.series[idx].setVisible(false, false);
          chart.series.map((s, i) => {
            s.setState("normal");
          });
        }
      });

      $(".hc-custom-legend").on("mouseover", function () {
        const idx = $(this).data("index");

        if (!chart.series[idx].visible) {
          return;
        }

        chart.series.map((s, i) => {
          s.setState("inactive");
        });
        chart.series[idx].setState("hover");
      });

      $(".hc-custom-legend").on("mouseout", function () {
        chart.series.map((s, i) => {
          s.setState("normal");
        });
      });

      $(".hclcb").each(function () {
        const elm = $(this);
        const label = elm.next().text();

        if (label.indexOf('(') >= 0) {
          console.log('label', label);
          elm.prop('checked', false);
          elm.trigger('change');
        }
      });
    });
  }
  // Charts /////////////////////////////////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////////////// END

  // Maps ///////////////////////////////////////////////////////////////////////////
  // ////////////////////////////////////////////////////////////////////////////////
  var mapCountry = document.getElementById("country-map");

  if (mapCountry) {
    const countryCode = mapCountry.getAttribute("data-country-code");
    const zoom = mapCountry.getAttribute("data-zoom")
      ? parseFloat(mapCountry.getAttribute("data-zoom"))
      : 3;

    // const countryID = JSON.parse(mapCountry.getAttribute("data-country-id"));

    const data = countryCode
      ? [[countryCode.toLowerCase(), 1, countryCode]]
      : [];

    const chart = Highcharts.mapChart("country-map", {
      chart: {
        map: mapData,
        aspectRatio: 1.6,
        backgroundColor: "#F9F9FA",
        // events: {
        //   load: function () {
        //     this.series[0].points.forEach(point => {
        //       point.graphic.element.onclick = () => {
        //         const isoCode = point.properties['iso-a2'] || point.properties['iso-a3'];
        //         const theUrl = window.location.href + '/country?country=';

        //         if (countryID && countryID.hasOwnProperty(isoCode)) {
        //           location.href = theUrl + countryID[isoCode];
        //         }

        //       };
        //     });
        //   }
        // }
      },
      title: {
        text: "",
      },
      mapNavigation: {
        enabled: true,
      },
      series: [
        {
          name: "",
          showInLegend: false,
          borderColor: "#fff",
          nullColor: "#C1C7D3",
          color: "#004587",
          keys: ["hc-key", "y", "id"],
          data: data,
          // cursor: 'pointer',
          tooltip: {
            useHTML: true,
            pointFormat: "<span>{point.name}</span>",
          },
        },
      ],
    });

    setTimeout(function () {
      if (data && countryCode) {
        chart.get(countryCode).zoomTo();
        chart.mapZoom(zoom);
      }
    }, 1000);
  }
  // Maps ///////////////////////////////////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////////////// END

  // Gender Quota Home - Map ////////////////////////////////////////////////////////
  // ////////////////////////////////////////////////////////////////////////////////
  var gqHomeMap = document.getElementById("gender-quota-home-map");

  if (gqHomeMap) {
    const data = $('#gender-quota-home-map').data('json');

    let gqdData = data.filter((item) => {
      return item.showOnGQDB === "1";
    });

    gqdData.map((item, idx) => {
      gqdData[idx]['hc-key'] = item.iso2.toLowerCase();
    });

    const chart = Highcharts.mapChart("gender-quota-home-map", {
      chart: {
        map: mapData,
        aspectRatio: 1.6,
        backgroundColor: "#F9F9FA",
        events: {
          load: function () {
            this.series[0].points.forEach(point => {
              point.graphic.element.onclick = () => {
                const theUrl = window.location.href + '/country?country=';

                if (point.tid !== undefined) {
                  location.href = theUrl + point.tid;
                }

              };
            });
          }
        }
      },
      title: {
        text: "",
      },
      mapNavigation: {
        enabled: true,
      },
      series: [
        {
          name: "",
          showInLegend: false,
          borderColor: "#fff",
          nullColor: "#C1C7D3",
          color: "#004587",
          keys: ["hc-key", "y", "id"],
          data: gqdData,
          cursor: 'pointer',
          tooltip: {
            useHTML: true,
            pointFormat: "<span>{point.name}</span>",
          },
        },
      ],
    });
  }
  // Gender Quota Home - Map ////////////////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////////////// END

  if ($("#highcharts-column-question-breakdown").length > 0) {
    const chartElm = $("#highcharts-column-question-breakdown");
    const question = chartElm.data("question");
    const choices = chartElm.data("choices");
    const values = chartElm.data("values");
    const total = chartElm.data("countries-researched");
    const chartTitle = chartElm.data("database-title");

    Highcharts.chart("highcharts-column-question-breakdown", {
      chart: {
        type: "column",
      },
      title: {
        text: question,
      },
      subtitle: {
        text: chartTitle + "<br>" + "Data for " + total + " countries",
      },
      xAxis: {
        categories: choices,
        crosshair: true,
      },
      yAxis: {
        min: 0,
        title: {
          enabled: false,
        },
      },
      tooltip: {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        formatter: function () {
          return (
            "<tr><td>Total: <b>" +
            this.y +
            "</b> (" +
            ((this.y / total) * 100).toFixed(2) +
            "%)</td></tr>"
          );
        },
        footerFormat: "</table>",
        shared: true,
        useHTML: true,
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0,
        },
      },
      series: [
        {
          name: question,
          data: values,
        },
      ],
    });
  }

  // Single Question Maps (choices) /////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////////////
  $(".question-map").each(function () {
    const elm = $(this);
    const id = elm.attr("id");
    const themeId = elm.data("tid");
    const questionId = elm.data("qid");
    const questionTitle = elm.data("question");
    const chartTitle = elm.data("database-title");
    const region = elm.data("region");
    const type = elm.data("type");

    const questionMap = Highcharts.mapChart({
      chart: {
        renderTo: id,
        map: mapData,
        backgroundColor: "#F9F9FA",
      },
      title: {
        text: questionTitle,
      },
      subtitle: {
        text: chartTitle,
      },
      mapNavigation: {
        enabled: true,
        buttonOptions: {
          align: "right",
          verticalAlign: "bottom",
        },
      },
      legend: {
        align: "left",
        floating: true,
        itemStyle: {
          width: "150px",
          textOverflow: "initial",
        },
        // width: "150px",
        layout: "vertical",
        verticalAlign: "middle",
      },
      // credits: {
      //   enabled: false,
      // },
      colorAxis: {
        dataClasses: [],
        min: 0,
      },
      series: [
        {
          name: "",
          allowPointSelect: true,
          animation: true,
          cursor: "pointer",
          showInLegend: false,
          data: [],
          nullColor: "#C1C7D3",
          states: {
            hover: {
              color: "#E5E7E9",
              borderColor: "#dfdfdf",
              borderWidth: 1,
            },
          },
        },
      ],
      tooltip: {
        useHTML: true,
        formatter: function () {
          return `<span style="font-size: 12px"><strong>${this.point.name}</strong><br/>${this.point.answer}</span>`;
        },
      },
    });
    questionMap.showLoading("Loading..");

    let apiURL = `/api/mapdatasinglequestion?theme=${themeId}&question=${questionId}`;

    if (type && region) {
      apiURL = `/api/mapdataregionwithsinglequestion?theme=${themeId}&question=${questionId}&type=${type}&region=${region}`;
    }

    const settings = {
      url: apiURL,
      method: "GET",
      timeout: 0,
      headers: {
        "Content-Type": "application/json",
      },
      error: function (error) {
        console.log("error", error);
        questionMap.showLoading("Error loading data from API");
      },
    };

    $.ajax(settings).done(function (response) {
      questionMap.series[0].setData(response.mapData);
      questionMap.colorAxis[0].update({
        dataClasses: response.mapLegends,
      });
      questionMap.redraw();
      questionMap.hideLoading();
    });
  });
  // Single Question Maps (choices) ////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////// END

  // Single Question Maps (numeric) /////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////////////
  $(".question-map-numeric").each(function () {
    const elm = $(this);
    const id = elm.attr("id");
    const questionTitle = elm.data("question");
    const chartTitle = elm.data("database-title");
    const valueSuffix = elm.data("value-suffix");
    const dataTableId = elm.data("datatable");

    if ($(dataTableId).length === 0) {
      elm.parents(".question-map-wrapper").hide();
      return;
    }

    const dataTableRows = $(dataTableId).find("tbody tr");

    // Convert the cells into an array of objects
    const data = dataTableRows
      .map(function () {
        return {
          "hc-key": $(this).data("code"),
          country: $(this).data("country"),
          value: parseFloat($(this).data("value")),
        };
      })
      .get();

    const questionMapNumeric = Highcharts.mapChart({
      chart: {
        renderTo: id,
        map: mapData,
        backgroundColor: "#F9F9FA",
      },
      title: {
        text: questionTitle,
      },
      subtitle: {
        text: chartTitle,
      },
      xAxis: {
        labels: {
          enabled: false,
        },
      },
      mapNavigation: {
        enabled: true,
        buttonOptions: {
          align: "right",
          verticalAlign: "bottom",
        },
      },
      colorAxis: {
        min: 0,
        labels: {
          format: "{value}",
        },
        minColor: "#BFD1E1",
        maxColor: "#0A2E5F",
      },
      series: [
        {
          name: questionTitle,
          data: data,
          states: {
            hover: {
              color: "#E5E7E9",
              borderColor: "#dfdfdf",
              borderWidth: 1,
            },
          },
        },
      ],
      tooltip: {
        useHTML: true,
        formatter: function () {
          return `<span style="font-size: 12px"><strong>${this.point.country}:</strong> ${this.point.value}${valueSuffix}</span>`;
        },
      },
    });
  });
  // Single Question Maps (numeric) ////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////// END

  // Voter Turnout DB - region bar chart ////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////////////
  if ($(".chart-bar-region-293").length > 0) {
    // Process data from table
    $(".chart-bar-region-293").each(function () {
      let countries = {};
      let series = {};

      const elm = $(this);
      const chartId = elm.attr("id");
      const questionTitle = elm.data("question");
      const databaseTitle = elm.data("database-title");
      const region = elm.data("region");
      const subtheme = elm.data("subtheme");
      const datatableId = elm.data("datatable");
      const datatable = datatableId
        ? $(datatableId).find(".highcharts-data-col")
        : $(".highcharts-data-col");
      const standalone = elm.data("standalone");

      datatable.each(function () {
        const subtheme = $(this).data("subtheme");
        const country = $(this).data("country");
        const value = parseFloat($(this).data("value"));

        if (!series.hasOwnProperty(subtheme)) {
          series[subtheme] = {
            name: subtheme,
            data: [],
          };
        }

        if (!countries.hasOwnProperty(subtheme)) {
          countries[subtheme] = [];
        }

        series[subtheme].data.push({
          country,
          y: value,
        });
        // countries[subtheme].push(country);
      });

      if (
        !(series.hasOwnProperty(subtheme) && countries.hasOwnProperty(subtheme))
      ) {
        $("#" + chartId).html(
          "<p class='text-desktopS'>Chart not available</p>"
        );
        // Continue to the next iteration
        return true;
      }

      series[subtheme].data = series[subtheme].data.sort(function (a, b) {
        return b.y - a.y; // Sort in descending order based on "y" property
      });

      countries[subtheme] = [];

      $.each(series[subtheme].data, function () {
        countries[subtheme].push($(this)[0].country);
      });

      if (
        !(series.hasOwnProperty(subtheme) && countries.hasOwnProperty(subtheme))
      ) {
        $("#" + chartId).html(
          "<p class='text-desktopS'>Chart not available</p>"
        );
        // Continue to the next iteration
        return true;
      }

      const chartSeries = [series[subtheme]];
      const chartCategories = countries[subtheme];
      const pointWidth = 16; // each point data bar height
      const totalCategories = chartCategories.length;
      const groupPadding = 0.1;
      const extraGap = 300;
      const chartHeight =
        pointWidth * totalCategories +
        groupPadding * totalCategories +
        extraGap;

      let chartSubtitle;

      if (standalone == 1) {
        chartSubtitle = databaseTitle + " (" + chartSeries[0].data.length + " countries, data for the most recent elections)";
      } else {
        chartSubtitle = databaseTitle;
      }

      const barChart = Highcharts.chart(chartId, {
        chart: {
          type: "bar",
          height: chartHeight,
        },
        title: {
          text: questionTitle,
        },
        subtitle: {
          // text: databaseTitle + "(" + chartSeries[0].data.length + ") countries, data for the most recent elections)",
          // text: databaseTitle,
          text: chartSubtitle
        },
        xAxis: {
          categories: chartCategories,
          title: {
            text: null,
          },
          gridLineWidth: 1,
          lineWidth: 0,
        },
        yAxis: {
          min: 0,
          max: 100,
          title: {
            text: null,
            align: "high",
          },
          labels: {
            overflow: "allow",
            format: "{value}%",
          },
          gridLineWidth: 0,
        },
        tooltip: {
          valueSuffix: "%",
        },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: true,
              format: "{point.y}%",
            },
            groupPadding: groupPadding,
            pointWidth: pointWidth,
          },
        },
        legend: {
          enabled: false,
        },
        series: chartSeries,
      });
    });
  }
  // Voter Turnout DB - region bar chart ///////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////// END

  const countryLineChart = $("#country-line-chart-compact");

  if (countryLineChart.length > 0) {
    const settings = {
      url:
        "/api/chartvoterturnout?type=country&id=" +
        countryLineChart.data("country"),
      method: "GET",
      timeout: 0,
      headers: {
        "Content-Type": "application/json",
      },
      error: function (error) {
        console.log("error", error);
      },
    };

    $.ajax(settings).done(function (response) {
      var data = response;

      if (response.length <= 0) {
        $('#grid-col-vtd').remove();
        return;
      }

      var years = [];
      data.forEach(function (dataset) {
        dataset.data.forEach(function (data) {
          if (!years.includes(data.year) && data.value !== null) {
            years.push(data.year);
          }
        });
      });
      years.sort();

      var datasets = [];
      data.forEach(function (dataset) {
        let lineWidth = 1;

        if (dataset.title.indexOf('Continent') > 0 || dataset.title.indexOf('Region') > 0) {
          lineWidth = 2;
        }

        if (dataset.title.indexOf('Global') > 0) {
          lineWidth = 4;
        }

        var newDataset = {
          name: dataset.title,
          data: [],
          lineWidth: lineWidth,
        };

        years.forEach(function (year) {
          var dataItem = dataset.data.find(function (item) {
            return item.year === year;
          });

          if (dataItem) {
            newDataset.data.push(dataItem.value);
          } else {
            newDataset.data.push(null);
          }
        });

        datasets.push(newDataset);
      });

      datasets.map((d, idx) => {
        if (d.name.indexOf("Parliamentary") < 0) {
          d.visible = false;
        }
      });

      var customTickPositions = [0, 20, 40, 60, 80, 100];
      Highcharts.chart({
        chart: {
          renderTo: "country-line-chart-compact",
          type: "line",
          backgroundColor: "transparent",
        },
        title: { text: "" },
        exporting: {
          enabled: false,
        },
        xAxis: {
          categories: years.map(String),
        },
        yAxis: {
          title: "",
          tickPositions: customTickPositions,
          labels: {
            format: "{text}%",
          },
        },
        tooltip: {
          valueSuffix: "%",
        },
        plotOptions: {
          line: {
            connectNulls: true,
          },
          series: {
            marker: {
              enabled: false,
              states: {
                hover: {
                  enabled: true,
                },
              },
            },
          },
        },
        series: datasets,
      });
    });
  }
});
